import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Admin.css";

const LogAktivitas = () => {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/log_aktivitas",
          { withCredentials: true }
        );
        setLogs(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Gagal mengambil log aktivitas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  // Parse data log dari format "- {activity} ({waktu})"
  const parsedLogs = useMemo(() => {
    return logs.map((logItem, index) => {
      const cleanText = (typeof logItem === "string" ? logItem : "")
        .replace(/^-\s*/, "")
        .trim();

      const lastOpenParen = cleanText.lastIndexOf(" (");
      const lastCloseParen = cleanText.lastIndexOf(")");

      let activity = cleanText;
      let time = "-";

      if (
        lastOpenParen !== -1 &&
        lastCloseParen !== -1 &&
        lastCloseParen > lastOpenParen
      ) {
        activity = cleanText.substring(0, lastOpenParen).trim();
        time = cleanText.substring(lastOpenParen + 2, lastCloseParen).trim();
      }

      return {
        id: index + 1,
        activity,
        time,
      };
    });
  }, [logs]);

  // Filter pencarian (mencari di aktivitas maupun waktu)
  const filteredLogs = useMemo(() => {
    if (!searchTerm.trim()) return parsedLogs;
    const term = searchTerm.toLowerCase();
    return parsedLogs.filter(
      (item) =>
        item.activity.toLowerCase().includes(term) ||
        item.time.toLowerCase().includes(term)
    );
  }, [parsedLogs, searchTerm]);

  // Pagination kalkulasi
  const totalPages = Math.ceil(filteredLogs.length / itemsPerPage) || 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentLogs = filteredLogs.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="bg-light min-vh-100 p-4 w-100">
      <div className="mx-auto" style={{ maxWidth: "1140px" }}>
        
        {/* Header Bar */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
          <div>
            <button
              className="btn btn-outline-secondary btn-sm rounded-pill px-3 mb-2"
              onClick={() => navigate(-1)}
            >
              ← Kembali ke Dashboard
            </button>
            <h2 className="fw-bold text-dark mb-1">Audit Log Aktivitas</h2>
            <p className="text-muted small mb-0">
              Rekam jejak seluruh aktivitas dan aksi pengguna di dalam sistem.
            </p>
          </div>

          {/* Kolom Pencarian */}
          <div style={{ width: "300px" }}>
            <div className="input-group shadow-sm">
              <span className="input-group-text bg-white border-end-0 rounded-start-pill text-muted">
                🔍
              </span>
              <input
                type="text"
                className="form-control border-start-0 rounded-end-pill py-2"
                placeholder="Cari aktivitas atau waktu..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1); // Kembali ke page 1 saat mencari
                }}
              />
            </div>
          </div>
        </div>

        {/* Card Table (Div Based - Anti Crash DataTables) */}
        <div className="card rounded-4 border-0 shadow-sm bg-white overflow-hidden w-100">
          
          {/* Header Tabel */}
          <div className="d-flex bg-light py-3 px-4 text-secondary small fw-bold border-bottom">
            <div style={{ width: "60px" }}>#</div>
            <div className="flex-grow-1">AKTIVITAS PENGGUNA</div>
            <div style={{ width: "260px" }} className="text-end">WAKTU EKSEKUSI</div>
          </div>

          {/* Konten Log */}
          <div className="p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status"></div>
                <p className="text-muted mt-2 small">Memuat log aktivitas...</p>
              </div>
            ) : filteredLogs.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <span className="fs-1">📂</span>
                <p className="mt-2 mb-0">Tidak ada riwayat aktivitas yang cocok.</p>
              </div>
            ) : (
              currentLogs.map((item, index) => {
                const isLogin = item.activity.toLowerCase().includes("login");
                return (
                  <div
                    key={index}
                    className="d-flex align-items-center py-3 px-4 border-bottom bg-white hover-bg-light"
                    style={{ transition: "background-color 0.2s" }}
                  >
                    <div className="text-muted small" style={{ width: "60px" }}>
                      {indexOfFirstItem + index + 1}
                    </div>

                    <div className="flex-grow-1 d-flex align-items-center gap-3 pe-3">
                      <div
                        className={`rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 ${
                          isLogin ? "bg-success-subtle text-success" : "bg-primary-subtle text-primary"
                        }`}
                        style={{ width: "36px", height: "36px" }}
                      >
                        <span>{isLogin ? "🔑" : "⚡"}</span>
                      </div>
                      <span className="fw-semibold text-dark" style={{ fontSize: "0.95rem" }}>
                        {item.activity}
                      </span>
                    </div>

                    <div
                      className="text-end text-muted small text-nowrap"
                      style={{ width: "260px", fontSize: "0.85rem" }}
                    >
                      🗓️ {item.time}
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Footer & Pagination Navigasi */}
          {!loading && filteredLogs.length > 0 && (
            <div className="card-footer bg-white border-top py-3 px-4 d-flex flex-wrap justify-content-between align-items-center gap-2">
              <span className="text-muted small">
                Menampilkan <b>{indexOfFirstItem + 1}</b> -{" "}
                <b>{Math.min(indexOfLastItem, filteredLogs.length)}</b> dari total{" "}
                <b>{filteredLogs.length}</b> aktivitas
              </span>

              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Sebelumnya
                    </button>
                  </li>

                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(
                      (page) =>
                        page === 1 ||
                        page === totalPages ||
                        (page >= currentPage - 1 && page <= currentPage + 1)
                    )
                    .map((page, idx, arr) => {
                      const prev = arr[idx - 1];
                      return (
                        <React.Fragment key={page}>
                          {prev && page - prev > 1 && (
                            <li className="page-item disabled">
                              <span className="page-link">...</span>
                            </li>
                          )}
                          <li className={`page-item ${currentPage === page ? "active" : ""}`}>
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(page)}
                            >
                              {page}
                            </button>
                          </li>
                        </React.Fragment>
                      );
                    })}

                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Berikutnya
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default LogAktivitas;